import { useTranslator } from '@picsart/rc/services/localization';

import useUploadMessage from '@/hooks/useUploadMessage';

import useStyles from './styles';

import type { UploadStatus } from '@/types/upload';

/**
 * What the feed's Recreate pill says while a pick uploads: a message that
 * escalates with elapsed time, and three pulsing dots. Replaces the DS button's
 * `isLoading` spinner, which blanks the label entirely — a textless pill is what
 * users mistake for a crash.
 *
 * Renders only for the upload leg, so mounting is the message clock's zero (see
 * `useUploadMessage`). All spans: this sits inside the button's own content span.
 */
const UploadStatusLabel = ({ mediaType }: UploadStatus) => {
  const classes = useStyles();
  const translate = useTranslator();
  const message = useUploadMessage(mediaType);

  return (
    <span className={classes.row} data-testid="upload-status-label">
      <span className={classes.message}>{translate(message)}</span>
      {/* Standing in for the copy's ellipsis, and carrying the liveness the
          copy can't: a swell travelling across three dots reads as "work is
          happening", where a static "..." reads as frozen. Empty spans — they
          are drawn as circles, so a glyph inside would print through them.
          Decorative: the message already says all of this. */}
      <span className={classes.dots} aria-hidden="true">
        <span className={classes.dot} />
        <span className={classes.dot} />
        <span className={classes.dot} />
      </span>
    </span>
  );
};

export default UploadStatusLabel;
